import { render, staticRenderFns } from "./editObservation.vue?vue&type=template&id=69bf62c6&scoped=true&"
import script from "./editObservation.vue?vue&type=script&lang=js&"
export * from "./editObservation.vue?vue&type=script&lang=js&"
import style0 from "./editObservation.vue?vue&type=style&index=0&id=69bf62c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bf62c6",
  null
  
)

export default component.exports